import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./index.scss";
import { technologies, tools } from "../../data/skills";
import {
  faEnvelope,
  faPhone,
  faCode,
  faLocation,
} from "@fortawesome/free-solid-svg-icons";

const About = () => {
  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>About me</h1>
          <div className="info">
            <div>
              <p>
                I'm Chirag Boghara, a Senior Flutter Developer and Mobile App
                Developer based in Surat, India. I build cross-platform apps for
                Android and iOS from a single Flutter and Dart codebase, with
                clean architecture, smooth animations and production-ready
                performance.
              </p>
              <p>
                As an AI Apps Developer, I integrate LLMs, chatbots, smart
                search and AI-powered features into Flutter mobile apps. As a
                Flutter UI Developer and Flutter API Integration Developer, I
                turn Figma designs into pixel-perfect screens and connect them
                to REST APIs, third-party SDKs, payments and real-time data.
              </p>
              <p>
                Beyond mobile, I'm a Full-Stack Developer. I build backends and
                web apps with the MERN stack (MongoDB, Express.js, React,
                Node.js), and I'm an experienced Firebase Developer and Supabase
                Developer for authentication, databases, storage, push
                notifications and cloud functions. I've also shipped hybrid apps
                with Ionic and Angular.
              </p>
              <p>
                I work as a Freelance Flutter Developer with startups and
                businesses worldwide, taking apps from idea and MVP all the way
                to launch on the Google Play Store and Apple App Store.
              </p>
              <p className="msg">
                Have an app idea or need a senior Flutter developer on your
                team? Let's talk. Drop me an email or message me on WhatsApp. ⚡
              </p>
            </div>
            <div className="avatar">
              <img
                src="/assets/images/profile.webp"
                alt="Chirag Boghara, Senior Full-Stack Flutter Mobile App Developer"
              />
              <div className="resume-btn">
                <a
                  href="https://drive.google.com/file/d/1MeMqZ3BqGMynzw6YJxHz3xLvF_T5Rikh/view?usp=sharing"
                  target="_blank"
                  rel="noreferrer"
                >
                  View Resume
                  <span className="sr-only"> (opens in new tab)</span>
                </a>
              </div>
              <div className="tiles">
                <span className="tile">
                  <FontAwesomeIcon size="lg" icon={faLocation} />
                  <span>Surat, India.</span>
                </span>
                <span className="tile">
                  <FontAwesomeIcon size="lg" icon={faEnvelope} />
                  <span>
                    <a href="mailto:chiragboghara26@gmail.com">
                      chiragboghara26@gmail.com
                    </a>
                  </span>
                </span>
                <span className="tile">
                  <FontAwesomeIcon size="lg" icon={faPhone} />
                  <span>+91 9909150454</span>
                </span>
                <span className="tile">
                  <FontAwesomeIcon size="lg" icon={faCode} />
                  <span>
                    <a href="https://leetcode.com/u/chirag_boghara/">
                      Leetcode Profile
                    </a>
                  </span>
                </span>
              </div>
            </div>
          </div>

          <h2>Programming Languages</h2>
          <div className="list languages">
            <img src="/assets/images/c.svg" alt="C" width="30" height="30" />
            <img
              src="/assets/images/cplusplus.svg"
              alt="C++"
              width="30"
              height="30"
            />
            <img
              src="/assets/images/javascript.svg"
              alt="JavaScript"
              width="30"
              height="30"
            />
            <img
              src="/assets/images/typescript.svg"
              alt="TypeScript"
              width="30"
              height="30"
            />
            <img src="/assets/images/dart.svg" alt="Dart" width="30" height="30" />
          </div>
          <h2>Technologies</h2>
          <div className="list">
            <ul>
              {technologies.map((tool) => {
                return (
                  <li key={tool.title}>
                    <img
                      src={tool.image}
                      alt={tool.title}
                      width="30"
                      height="30"
                      loading="lazy"
                    />
                    <span key={tool.title}>
                      <p className="tool-title">{tool.title} - </p>
                      <p className="tool-desc">{tool.description}</p>
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
          <h2>Tools</h2>
          <div className="list">
            <ul>
              {tools.map((tool) => {
                return (
                  <li key={tool.title}>
                    <img
                      src={tool.image}
                      alt={tool.title}
                      width="30"
                      height="30"
                      loading="lazy"
                    />
                    <span key={tool.title}>
                      <p className="tool-title">{tool.title} - </p>
                      <p className="tool-desc">{tool.description}</p>
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
